

import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { z } from "zod";
import { toast } from "sonner";
import { baseURL } from "../../../Utils/constants/constant";
import { PostRequest } from "../../../Utils/hooks/ApiHandler";

export default function ComposeOffcanvas({
  open,
  onClose,
  mail,
  type = "new",
  recipients = [],
    originalMail,
}) {
  const [composeData, setComposeData] = useState({
    to: "",
    cc: "",
    bcc: "",
    subject: "",
    body: "",
    attachments: [],
  });

  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);

  const accessToken = sessionStorage.getItem("email_access_token");

  /* ================= AUTO FILL (Reply / ReplyAll / Forward) ================= */
  // useEffect(() => {
  //   if (!open) return;

  //   if (!mail) {
  //     setComposeData({
  //       to: "",
  //       cc: "",
  //       bcc: "",
  //       subject: "",
  //       body: "",
  //       attachments: [],
  //     });
  //     return;
  //   }

  //   if (type === "reply" || type === "replyAll") {
  //     setComposeData({
  //       to: recipients.join(", "),
  //       cc: "",
  //       bcc: "",
  //       subject: `Re: ${mail.subject || ""}`,
  //       body: `<br/><br/>----- Original Message -----<br/>${mail.bodyPreview || ""}`,
  //       attachments: [],
  //     });
  //   }

  //   if (type === "forward") {
  //     setComposeData({
  //       to: "",
  //       cc: "",
  //       bcc: "",
  //       subject: `Fwd: ${mail.subject || ""}`,
  //       body: `<br/><br/>----- Forwarded Message -----<br/>${mail.bodyPreview || ""}`,
  //       attachments: [],
  //     });
  //   }

  //   if (type === "new") {
  //     setComposeData({
  //       to: "",
  //       cc: "",
  //       bcc: "",
  //       subject: "",
  //       body: "",
  //       attachments: [],
  //     });
  //   }
  // }, [type, mail, recipients, open]);

  const normalizeSubject = (subject = "") => {
  // remove multiple Re:
  let s = subject.replace(/^(Re:\s*)+/i, "");

  // remove multiple PUG_CRM
  s = s.replace(/^(PUG_CRM\s*)+/i, "");

  return s.trim();
};
//   useEffect(() => {
//   if (!mail) return;

//   const originalBody =
//     originalMail?.body?.content ||
//     originalMail?.bodyPreview ||
//     "";

//   if (type === "reply" || type === "replyAll") {
//     setComposeData({
//       to: recipients.join(", "),
//       cc: "",
//       bcc: "",
//       subject: `Re: ${mail.subject || ""}`,
//       body: `
//         <br/><br/>
//         <hr/>
//         <b>From:</b> ${mail.from?.emailAddress?.address}<br/>
//         <b>Sent:</b> ${new Date(mail.sentDateTime).toLocaleString()}<br/>
//         <b>Subject:</b> ${mail.subject}<br/>
//         <br/>
//         ${originalBody}
//       `,
//       attachments: [],
//     });
//   }

//   if (type === "forward") {
//     setComposeData({
//       to: "",
//       cc: "",
//       bcc: "",
//       subject: `Fwd: ${mail.subject || ""}`,
//       body: `
//         <br/><br/>
//         <hr/>
//         <b>---------- Forwarded message ----------</b><br/>
//         <b>From:</b> ${mail.from?.emailAddress?.address}<br/>
//         <b>Sent:</b> ${new Date(mail.sentDateTime).toLocaleString()}<br/>
//         <b>Subject:</b> ${mail.subject}<br/>
//         <br/>
//         ${originalBody}
//       `,
//       attachments: [],
//     });
//   }
// }, [type, mail, originalMail, recipients]);


useEffect(() => {
  if (!mail || !open) return;

  const baseSubject = normalizeSubject(mail.subject || "");

  const originalBody =
    originalMail?.body?.content ||
    originalMail?.bodyPreview ||
    "";

  if (type === "reply" || type === "replyAll") {
    setComposeData({
      to: recipients.join(", "),
      cc: "",
      bcc: "",
      subject: `Re: PUG_CRM ${baseSubject}`,
      body: `
        <br/><br/>
        <hr/>
        <b>From:</b> ${mail.from?.emailAddress?.address || ""}<br/>
        <b>Sent:</b> ${new Date(mail.sentDateTime).toLocaleString()}<br/>
        <b>Subject:</b> ${mail.subject || ""}<br/>
        <br/>
        ${originalBody}
      `,
      attachments: [],
    });
  }

  if (type === "forward") {
    setComposeData({
      to: "",
      cc: "",
      bcc: "",
      subject: `Fwd: PUG_CRM ${baseSubject}`,
      body: `
        <br/><br/>
        <hr/>
        <b>---------- Forwarded message ----------</b><br/>
        <b>From:</b> ${mail.from?.emailAddress?.address || ""}<br/>
        <b>Sent:</b> ${new Date(mail.sentDateTime).toLocaleString()}<br/>
        <b>Subject:</b> ${mail.subject || ""}<br/>
        <br/>
        ${originalBody}
      `,
      attachments: [],
    });
  }

  if (type === "new") {
    resetForm();
  }
}, [type, mail, originalMail, recipients, open]);


  if (!open) return null;

  /* ================= FILE ================= */
  const onSelectFiles = (e) => {
    setComposeData((d) => ({
      ...d,
      attachments: [...e.target.files],
    }));
  };

  /* ================= VALIDATION ================= */
  const composeSchema = z.object({
    to: z.string().min(1, "Recipient is required"),
    subject: z.string().min(1, "Subject is required"),
    body: z.string().min(1, "Message body is required"),
  });

  /* ================= SEND ================= */
  // const onSend = async () => {
  //   setErrors({});

  //   const parsed = composeSchema.safeParse(composeData);
  //   if (!parsed.success) {
  //     const fieldErrors = {};
  //     parsed.error.errors.forEach((err) => {
  //       fieldErrors[err.path[0]] = err.message;
  //     });
  //     setErrors(fieldErrors);
  //     return;
  //   }

  //   setSending(true);

  //   try {
  //     const payload = {
  //       accessToken,
  //       to: composeData.to.split(",").map((e) => e.trim()),
  //       subject: composeData.subject,
  //       body: composeData.body,
  //       attachments: await Promise.all(
  //         composeData.attachments.map(async (file) => ({
  //           "@odata.type": "#microsoft.graph.fileAttachment",
  //           name: file.name,
  //           contentType: file.type,
  //           contentBytes: await toBase64(file),
  //         }))
  //       ),
  //     };

  //     const res = await fetch("http://localhost:5000/api/outlook/send-mail", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!res.ok) throw new Error();

  //     toast.success("Email sent");
  //     onClose();
  //     resetForm()
  //   } catch {
  //     toast.error("Failed to send email");
  //   } finally {
  //     setSending(false);
  //     resetForm()
  //   }
  // };
  

  const onSend = async () => {
  setErrors({});

  const parsed = composeSchema.safeParse(composeData);
  if (!parsed.success) {
    const fieldErrors = {};
    parsed.error.errors.forEach((err) => {
      fieldErrors[err.path[0]] = err.message;
    });
    setErrors(fieldErrors);
    return;
  }

  setSending(true);

  try {
    const payload = {
      accessToken,
      to: composeData.to.split(",").map(e => e.trim()),
      subject: composeData.subject,
      body: composeData.body,
      attachments: await Promise.all(
        composeData.attachments.map(async (file) => ({
          "@odata.type": "#microsoft.graph.fileAttachment",
          name: file.name,
          contentType: file.type,
          contentBytes: await toBase64(file),
        }))
      ),
    };

//     const res = await PostRequest(
//   `${baseURL}inbox/sendmail`,
//   payload,
//   true,
//   {},
//   {}
// );
const res = await PostRequest(
  `${baseURL}inbox/sendmail`,
  payload,
  true,
  {
    "Content-Type": "application/json"
  },
  {}
);


    if (!res.status === "success") throw new Error();

    toast.success("Email sent");

    resetForm();        
    onClose();         
    window.dispatchEvent(new Event("mail-sent"));

  } catch {
    toast.error("Failed to send email");
  } finally {
    setSending(false);
  }
};

  const resetForm = () => {
  setComposeData({
    to: "",
    cc: "",
    bcc: "",
    subject: "",
    body: "",
    attachments: [],
  });
  setErrors({});
};

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100"
      style={{ zIndex: 1055 }}
    >
      {/* BACKDROP */}
      <div className="w-100 h-100 bg-dark bg-opacity-50" onClick={onClose} />

      {/* OFFCANVAS */}
      <div
        className="position-absolute top-0 end-0 h-100 bg-white border-start d-flex flex-column"
        style={{ width: "820px", maxWidth: "100vw" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <div className="fw-semibold fs-5">
            {type === "reply"
              ? "Reply"
              : type === "replyAll"
              ? "Reply All"
              : type === "forward"
              ? "Forward"
              : "New Email"}
          </div>
          <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Close
          </button>
        </div>

        {/* BODY */}
        <div className="flex-grow-1 overflow-auto p-3">
          <div className="row g-3">
            <Input
              label="To"
              value={composeData.to}
              error={errors.to}
              onChange={(v) => setComposeData((d) => ({ ...d, to: v }))}
            />

            <Input
              label="Subject"
              col="12"
              value={composeData.subject}
              error={errors.subject}
              onChange={(v) =>
                setComposeData((d) => ({ ...d, subject: v }))
              }
            />

            <div className="col-12">
              <label className="form-label">Message</label>
              <ReactQuill
                theme="snow"
                value={composeData.body}
                onChange={(v) =>
                  setComposeData((d) => ({ ...d, body: v }))
                }
                style={{ minHeight: 240 }}
              />
              {errors.body && (
                <div className="text-danger small mt-1">{errors.body}</div>
              )}
            </div>

            <div className="col-12">
              <label className="form-label">Attachments</label>
              <input
                type="file"
                multiple
                className="form-control"
                onChange={onSelectFiles}
              />
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="border-top p-3 d-flex justify-content-end gap-2">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            disabled={sending}
            onClick={onSend}
          >
            {sending ? "Sending..." : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ================= INPUT ================= */
function Input({ label, value, onChange, error, col = "6" }) {
  return (
    <div className={`col-md-${col}`}>
      <label className="form-label">{label}</label>
      <input
        className={`form-control ${error ? "is-invalid" : ""}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
}

/* ================= BASE64 ================= */
const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
